import * as React from 'react';
export const umbSvg = React.forwardRef(function umbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#003C6E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M2.595 19.028h26.81v1H2.595zm18.77-.89v-6.03h6.35c.42 0 1.48.25 1.48 1.5 0 1.26-.64 1.01-.85 1.26.43 0 1.06.5 1.06 1.5 0 1.01-.85 1.77-1.48 1.77h-6.56zm2.53-4.53v.75h2.11c.24 0 .43-.17.43-.38 0-.2-.2-.37-.43-.37h-2.11zm0 2v1.01h2.47a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-2.47zm-12.363 2.526v-6.026h3.453L16 15.623l1.016-3.515h3.453v6.026h-2.234v-4.017l-1.219 4.017h-2.031l-1.219-4.017v4.017zm-8.937-6.026h2.68v3.77c0 .5.45.75 1.34.75.9 0 1.34-.25 1.34-.75v-3.77h2.68v4.26c0 .76-1.71 1.77-4.02 1.77-2.46 0-4.02-1-4.02-1.76v-4.27z',
        fill: '#FFF',
      }),
    ),
  );
});
umbSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var umb = {
  category: 'brand',
  colorable: false,
  name: 'umb',
  svg: umbSvg,
};
